import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import IconicDestinations from "./sections/IconicDestinations";
import SecurityIntelligenceFooter from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <Header />
      <IconicDestinations />
      <SecurityIntelligenceFooter />
    </div>;
}